import { COMPONENT_STATES, COMPONENT_TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS } from 'common/constants';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock, CreationContextFor } from '../creation-types';

export const googleLogin = ({
	dictionary,
}: CreationContextFor<typeof COMPONENT_TYPE.GOOGLE_LOGIN>): CreatedBuildingBlock<typeof COMPONENT_TYPE.GOOGLE_LOGIN> =>
	createModel({
		type: COMPONENT_TYPE.GOOGLE_LOGIN,
		componentProps: {
			other: {},
			styles: {},
		},
		children: {
			[COMPONENT_STATES.DEFAULT]: {
				[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: dictionary.GOOGLE_LOGIN.label,
			},
		},
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.GOOGLE_LOGIN>;
